import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem
} from '../../ui/dropdown-menu';
import { MoreVertical } from 'lucide-react';

function DriverMenu({ onAdd, onRefresh }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="btn btn-sm btn-outline-secondary">
          <MoreVertical size={18} />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent>
        <DropdownMenuItem onClick={onAdd}>➕ Add New Driver</DropdownMenuItem>
        <DropdownMenuItem onClick={onRefresh}>⟳ Refresh Vehicle List</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default DriverMenu;
